module.exports = __webpack_public_path__ + "static/media/parmesan.ffab156c.png";